const defaultOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

const formatDate = (
  date: string,
  overwriteOptions: Intl.DateTimeFormatOptions = null,
) => {
  if (!date) return '';

  const options = {
    ...defaultOptions,
    ...overwriteOptions,
  };

  const parsedDate = new Date(date);
  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }
  return parsedDate.toLocaleDateString('de-DE', options);
};

export default formatDate;
